import { render, staticRenderFns } from "./FundamentalGraduation.vue?vue&type=template&id=f9feb5dc&scoped=true"
import script from "./FundamentalGraduation.vue?vue&type=script&lang=js"
export * from "./FundamentalGraduation.vue?vue&type=script&lang=js"
import style0 from "./FundamentalGraduation.vue?vue&type=style&index=0&id=f9feb5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9feb5dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
